export default "__VITE_ASSET__7iRc5jDR__"